import React, { FunctionComponent } from 'react'
import { G, Path, Svg } from 'react-native-svg'

export const SideNavLibraryIcon: FunctionComponent<SideNavLibraryIconProps> = ({
  size = 32,
  fillColor,
  isFilled = false,
}) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none'>
      {isFilled ? (
        <G>
          <Path
            d='M18.9541 3.87305H18.9795C18.977 3.91352 18.9746 3.95417 18.9746 3.99512V8.80469C18.9745 9.24119 18.9354 10.4235 19.4629 11.4619C19.7625 12.0515 20.2387 12.6 20.9355 12.9795C21.6093 13.3463 22.3677 13.4892 23.1484 13.4893H26.6602C26.7458 13.4892 26.8305 13.4824 26.9141 13.4717L26.915 13.4795H28.6768V27.0371C28.6768 28.6938 27.3334 30.0368 25.6768 30.0371H6.32031C4.66357 30.037 3.32031 28.6939 3.32031 27.0371V4.96191C3.32031 3.30514 4.66357 1.96107 6.32031 1.96094H18.9541V3.87305ZM8.74902 22.8535C8.19682 22.8535 7.74916 23.3013 7.74902 23.8535C7.74902 24.4058 8.19674 24.8535 8.74902 24.8535H23.249C23.801 24.8531 24.249 24.4056 24.249 23.8535C24.2489 23.3016 23.8009 22.8539 23.249 22.8535H8.74902ZM8.74902 18.3682C8.19674 18.3682 7.74902 18.8159 7.74902 19.3682C7.74916 19.9203 8.19682 20.3682 8.74902 20.3682H19.9805C20.5322 20.3676 20.9803 19.92 20.9805 19.3682C20.9805 18.8162 20.5323 18.3687 19.9805 18.3682H8.74902ZM8.74902 13.7715C8.19674 13.7715 7.74902 14.2192 7.74902 14.7715C7.74902 15.3238 8.19674 15.7715 8.74902 15.7715H15.998C16.5501 15.7712 16.998 15.3236 16.998 14.7715C16.998 14.2194 16.5501 13.7717 15.998 13.7715H8.74902ZM26.6602 11.4893H23.1484C21.2465 11.4891 21.0082 10.2693 20.9785 9.2334L20.9746 8.80469C20.9747 7.71356 20.9746 3.99512 20.9746 3.99512L26.6602 11.4893Z'
            fill={fillColor}
          />
        </G>
      ) : (
        <G>
          <Path
            d='M20.9102 1.96289V3.96289H6.32422C5.80654 3.96289 5.38043 4.35622 5.3291 4.86035L5.32422 4.96289V27.0391C5.32432 27.5913 5.772 28.0391 6.32422 28.0391H25.6797C26.2319 28.0391 26.6796 27.5913 26.6797 27.0391V11.5059H28.6797V27.0391L28.6758 27.1934C28.598 28.7274 27.3681 29.9576 25.834 30.0352L25.6797 30.0391H6.32422L6.16992 30.0352C4.63594 29.9574 3.40593 28.7273 3.32812 27.1934L3.32422 27.0391V4.96289C3.32422 3.35779 4.58477 2.04711 6.16992 1.9668L6.32422 1.96289H20.9102Z'
            fill={fillColor}
          />
          <Path
            d='M23.2522 22.8552C23.8044 22.8554 24.2522 23.303 24.2522 23.8552C24.2522 24.4075 23.8044 24.8551 23.2522 24.8552H8.7522C8.19991 24.8552 7.7522 24.4075 7.7522 23.8552C7.7522 23.303 8.19991 22.8552 8.7522 22.8552H23.2522Z'
            fill={fillColor}
          />
          <Path
            d='M19.9836 18.3694C20.5357 18.3697 20.9836 18.8173 20.9836 19.3694C20.9836 19.9216 20.5357 20.3692 19.9836 20.3694H8.7522C8.19991 20.3694 7.7522 19.9217 7.7522 19.3694C7.7522 18.8171 8.19991 18.3694 8.7522 18.3694H19.9836Z'
            fill={fillColor}
          />
          <Path
            d='M16.0012 13.7729C16.5535 13.7729 17.0012 14.2206 17.0012 14.7729C17.0012 15.3252 16.5535 15.7729 16.0012 15.7729H8.7522C8.19991 15.7729 7.7522 15.3252 7.7522 14.7729C7.7522 14.2206 8.19991 13.7729 8.7522 13.7729H16.0012Z'
            fill={fillColor}
          />
          <Path
            d='M20.3405 2.10123C21.1545 1.82739 22.0529 2.10351 22.5719 2.78776L28.2565 10.2819C28.7155 10.887 28.7925 11.7003 28.4548 12.3805C28.117 13.0607 27.4231 13.4908 26.6637 13.4909H23.152C22.3713 13.4908 21.6129 13.3479 20.9391 12.9811C20.2422 12.6016 19.7661 12.0531 19.4665 11.4635C18.9389 10.4251 18.9781 9.24282 18.9782 8.80631V3.99674C18.9782 3.13793 19.5265 2.37508 20.3405 2.10123ZM20.9821 9.23502C21.0118 10.2709 21.2501 11.4907 23.152 11.4909H26.6637L20.9782 3.99674C20.9782 3.99674 20.9783 7.71528 20.9782 8.80631L20.9821 9.23502Z'
            fill={fillColor}
          />
        </G>
      )}
    </Svg>
  )
}

export type SideNavLibraryIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}
